export const API_DATE_REGEX = /^((?:19|20)\d{2})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
export const API_DATE_FORMAT = 'YYYY-MM-DD';
